import { render, staticRenderFns } from "./admin-logs.vue?vue&type=template&id=31286615&scoped=true&"
import script from "./admin-logs.vue?vue&type=script&lang=js&"
export * from "./admin-logs.vue?vue&type=script&lang=js&"
import style0 from "./admin-logs.vue?vue&type=style&index=0&id=31286615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31286615",
  null
  
)

export default component.exports